const preferences = {
  preferenceSettings: {
    nameAlreadyExist: '名前が繰り返されています',
    nameIsEmpty: '名前が空です',
    notificationPreference: 'サイトと対応する通知の優先設定を選択する',
    option1: '全サイトのEnphaseが推奨する通知を受け取りたい',
    option2: '通知をカスタマイズしたい',
    pageHeader: '環境設定',
    title: '通知オプションを選択する',
    saveDialogHeader: '変更を保存しますか？',
    saveConfirmText: '変更を保存しますか？',  
    cancelButton: '廃棄',
    saveButton: '保存',
    defaultDeselectWarning: '備考：デフォルト設定からサイトを削除することはできません',
    displayPreferences: '表示環境設定',
    ownSites: '自社サイト',
    otherSites: 'その他のサイト',
    emptySites: '利用可能なサイトはありません',
    emptyPreferenceSet: '環境設定がありません',
    preference: '環境設定',
    actions: 'アクション',
    settingsInfo: 'これらの設定は、Ensemble サイトにのみ適用されます',
    selectType: '環境設定',
    selectSite: 'サイト選択',
    selectSettings: '通知設定',
    addText: '追加',
    deleteAlertHeader: '削除の確認',
    deleteAlertDescription: 'この環境設定を完全に削除してもよろしいですか？',
    deleteAlertCancel: 'キャンセル',
    deleteAlertConfirm: 'Ok',
    siteEditWarning:
      'デフォルトでは、すべての所有サイトとその他のサイトの通知設定は、それぞれ「デフォルト設定 - 所有」と「デフォルト設定 - その他」に設定されています。',
    defaultOwnInfo: 'すべての所有サイトは「デフォルト設定 - 所有」に設定されています',
    defaultOtherInfo: '他のサイトはすべて「デフォルト設定 - その他」に設定されています',
    defaultInfo: 'すべてのサイトは「デフォルト設定」に設定されています',
    createNew: '新しい設定を追加する',
    siteEditWarningMinimal: 'デフォルトでは、サイトの通知設定は「デフォルト設定」に設定されています',
    selectAll: 'すべて選択',
    generalNotification: '一般通知',
    switchToNewPreferencePage: '新しい環境設定ページに切り替える'
  },
  preferences: {
    pageHeader: '環境設定',
    title: '環境設定',
    notificationPreference: '通知環境設定',
    activationNotification: 'アクティベーションの通知を送ってください。',
    monthlySummary: '毎月のシステムパフォーマンスのサマリーを送ってください。',
    newsletters: 'Enphase 製品またはサービスに関するニュースレター、プロモーション、アンケートを送ってください。',
    newLeadsNotification: '新しいリードとそのステータスの変更を通知する',
    alertEmail: 'アラートメールの環境設定',
    deviceEventsEmail: 'デバイスレベルのイベントについてメールを受け取る（影響レベルを下記から選択してください）：',
    exceptionsAlertEmail: 'システムごとに、アラートメールの環境設定に例外を指定することができます。',
    alertPreferences: 'システムごとのアラート環境設定を見る',
    saveNotificationPreferences: '通知環境設定の保存',
    displayPreferences: '表示環境設定',
    displayUnits: '表示単位',
    metric: 'メートル',
    imperial: 'インペリアル',
    saveDisplayPreferences: '表示環境設定の保存',
    systemAlert: 'システムアラートの環境設定：',
    saveChanges: '変更を保存する',
    label: 'デバイスレベルのイベントについてメールを受け取る（影響レベルを下記から選択してください）：',
    alertEmailPreference: 'アラートメールの環境設定',
    systems: 'システム'
  }
};

export default preferences;
